import classNames from 'classnames';
import styles from './style.module.scss';
import { useSelector } from 'react-redux';
const CustomTextarea = ({ Label, Required, Error, Value, Placeholder, Type, OnChange, NotRequiredMargin, OnKeyDown, CustomLabelStyle, CustomInputStyle, IsPassword, ReadOnly, Icon }) => {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    return (
        <div className={classNames('position-relative w-100', NotRequiredMargin ? '' : Error ? 'mb-0' : 'mb-3')}>
            <div className="d-flex flex-column">
                <label className={classNames(`${theme}FontBlackThree`, styles.textAreaLabel, CustomLabelStyle && CustomLabelStyle)}>
                    {Label} {!!Required && <label className={styles.asterik}>*</label>}
                    
                </label>
                <div className={classNames(styles.textAreatContainer, 'gap-2', `${theme}ModalBackground`) + ` ${ReadOnly ? styles.readonly : ''}`}>
                    {Icon && <Icon />}
                    <textarea
                        placeholder={Placeholder}
                        className={classNames(CustomInputStyle && CustomInputStyle, ` ${theme}FontColor`, styles.textAreaStyle, `${theme}ModalBackground`) + ` ${ReadOnly ? styles.readonly : ''}`}
                        value={Value}
                        onChange={OnChange}
                        readOnly={ReadOnly}
                    />
                </div>
            </div>
            {!!Error && <div className={styles.error}>{Error}</div>}
        </div>
    );
};

export default CustomTextarea;
